import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import type { RequestForm } from '../../../../../types/typeHelper';
import { debugLogger } from '../../../../helper/debugLogger';
import { openErrorDialog } from '../../../../slices/errorDialogSlice/errorDialogSlice';
import { useApiClient } from '../../client';

interface UseUploadMediaParams {
  form: RequestForm<'/chat/media/upload-url', 'post'>;
}

export function useUploadMediaMutation() {
  const client = useApiClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async ({ form }: UseUploadMediaParams) => {
      const { data } = await client.POST('/chat/media/upload-url', {
        body: form,
        bodySerializer(body) {
          const fd = new FormData();
          fd.append('file', body.file);
          return fd;
        },
      });
      return data;
    },
    // biome-ignore lint/suspicious/noExplicitAny: legacy boundary uses untyped external data
    onError: async (error: any) => {
      debugLogger('Failed to upload media:', error);
      dispatch(openErrorDialog({ dialogErrorMsg: error.message }));
    },
  });
}
